
import { Progress } from "@/components/ui/progress";

interface VideoLoadingIndicatorProps {
  isLoading: boolean;
  isFetchingMore: boolean;
  videosCount: number;
}

export function VideoLoadingIndicator({ isLoading, isFetchingMore, videosCount }: VideoLoadingIndicatorProps) {
  if (!isLoading && !isFetchingMore) return null;

  return (
    <div className="mb-4 bg-black/20 rounded-lg p-4">
      <div className="text-sm text-gray-300 mb-2">
        Loading videos... {videosCount > 0 ? `(${videosCount} loaded so far)` : ''}
      </div>
      <Progress value={undefined} className="h-1" />
    </div>
  );
}
